<template>
	<div class="acount-info-main-div">
		<div v-if="loginUser.account">
			<account-info-sub></account-info-sub>
		</div>

		<div class="trading-record-div">
			<trading-record-sub></trading-record-sub>
		</div>
	</div>
</template>

<script>
import TRADING_RECORD_SUB from '@/components/template/view/userInfo/tradingAccount/tradingRecord'
import ACCOUNT_INFO_SUB from '@/components/template/view/userInfo/tradingAccount/tradingAccountInfo'

export default {
	name: 'tradingAccountInfoPage',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg','LOGINUSER'],
	data() {return {
		loginUser : this.LOGINUSER,
	}},
	created() {

	},
	components:{
		'trading-record-sub' : TRADING_RECORD_SUB,
		'account-info-sub' : ACCOUNT_INFO_SUB
	},
	methods:{

	},
	watch: {},
}
</script>

<style scoped>
.acount-info-main-div{
	padding: 30px 20px;
}
.info-div{
	padding: 10px 0px;
	border-bottom: 1px solid #DCDFE6;
}
.rechage-btn{
	width: 140px;
	height: 45px;
	float: right;
	margin-right: 10px;
	margin-top: 5px;
	font-size: 18px;
}
</style>